module.exports = __webpack_public_path__ + "static/resources_page-5fc1984898639735cb117a0220e4d084.webp";